export default {
  getUser: (state) => {
    return {
      userName: state.userName,
      userImg: state.userImg
    }
  },
  getSideMenuShow: (state) => state.sideMenuShow,
  getCollapse: (state) => state.collapse,
  getModulesMenuShow: (state) => state.modulesMenuShow,
  getAuth: (state) => state.auth,
  getAuthHad: (state) => state.authHad,
  getRouter: (state) => state.router,
  getSysList: (state) => state.sysList,
  getUserInfo: (state) => state.userInfo,
  getTableQuery: (state) => state.tableQuery,
  getHeaderShow: (state) => state.headerShow,
  getKeepAliveRoutes: (state) => state.keepAliveRoutes,
}


// WEBPACK FOOTER //
// ./src/vuex/getters.js